import "./main.scss";

import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import ReactDOM from "react-dom";
import TagManager from "react-gtm-module";
import { Provider } from "react-redux";

import App from "./App";
import { SENTRY_DSN, ENV, TAG_MANAGER_ID } from "./env/env";
import * as serviceWorker from "./helpers/serviceWorker";
import { store } from "./redux";
import reportWebVitals from "./reportWebVitals";

TagManager.initialize({
  gtmId: TAG_MANAGER_ID,
});

Sentry.init({
  dsn: SENTRY_DSN,
  beforeBreadcrumb: (breadcrumb) =>
    breadcrumb?.category === "console" ? null : breadcrumb,
  maxBreadcrumbs: 5,
  environment: ENV,
  normalizeDepth: 4,
  integrations: [new Integrations.BrowserTracing(), Sentry.replayIntegration()],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.5,
  replaysOnErrorSampleRate: 1.0,
});

// eslint-disable-next-line react/no-deprecated
ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);
serviceWorker.register();
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
